import PrimaryButton from "Components/atoms/buttons/primary-button";
import { DocumentIcon } from "Components/atoms/icons";

interface EmptyStateProps {
    title?: string;
    subtitle?: string;
    buttonText?: string
    onClickButton?: () => any
}

const EmptyState: React.FC<EmptyStateProps> = ({
    title = "Nothing here yet",
    subtitle = "There’s no data to display right now.",
    buttonText,
    onClickButton
}) => {
    return (
        <div className="state-container">
            <div className="state-icon"><DocumentIcon className="text-body-secondary" /></div>
            <h4 className="state-title">{title}</h4>
            <p className="state-subtitle">{subtitle}</p>
            {buttonText && onClickButton && <PrimaryButton onClick={() => {
                onClickButton()
            }}>
                {buttonText}
            </PrimaryButton>}
        </div>
    )
}

export default EmptyState;